import { AssignmentTurnedIn, BorderColor, Check, Clear, ExpandMore, Handshake, Info, MoreHoriz, Print } from '@mui/icons-material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardHeader, Container, CssBaseline, Dialog, DialogContent, DialogTitle, Grid, IconButton, ListItemIcon, Menu, MenuItem, Tab, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import { getDatabase, ref, set } from 'firebase/database'
import React, { useEffect, useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import MyDialog from '../../../../components/MyDialog'
import MyTable from '../../../../components/MyTable'
import { AuthStore } from '../../../../store/UserStore'
import { updateFirebasePencairan } from '../../../../utils/Firebase'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'
import { DataSp2dDiserahkan } from '../sp2dDiserahkan/Index'
import { DataTtdSp2d } from '../TtdSp2d/Index'

const Menux = ({ data = {}, menyimpan, setMenyimpan }) => {
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogData, setDialogData] = useState({});
    const [openDialogPrint, setOpenDialogPrint] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const openOption = Boolean(anchorEl);

    const handleOpenDialog = () => {
        // console.log(data);
        setDialogData(data)
        handleCloseOption();
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOption = (event) => {
        setDialogData(data);
        setAnchorEl(event.currentTarget);
        console.log(anchorEl);
    };

    const handleCloseOption = () => {
        setAnchorEl(null);
        console.log(anchorEl.event);
    };

    const onCancel = () => {
        handleCloseOption();
        Swal.fire({
            title: 'Proses SP2D Dibatalkan?',
            text: "Masukkan Catatan Revisi",
            icon: 'warning',
            input: 'text',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Proses',
            cancelButtonText: 'Tutup',
            preConfirm: (revisi) => {
                console.log(dialogData);
                const frm = {
                    _method: "PUT",
                    no_spm: dialogData.no_spm,
                    progres: 2,
                    revisi: revisi
                };
                return axios.post(
                    base_url + '/verif/pencairan/update',
                    frm,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        setMenyimpan(!menyimpan)
                        updateProsesSP2D(response.data.prosesSP2D)
                        updateTtdSP2D(response.data.ttdSP2D)
                        updateFirebasePencairan(dialogData, 2)
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const onConfirm = () => {
        handleCloseOption();
        Swal.fire({
            title: 'SPM Ditandatangani?',
            // text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tutup',
            preConfirm: () => {
                const frm = {
                    _method: "PUT",
                    no_spm: dialogData.no_spm,
                    progres: 5
                };
                return axios.post(
                    base_url + '/verif/pencairan/update',
                    frm,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        setMenyimpan(!menyimpan)
                        updateProsesSP2D(response.data.prosesSP2D)
                        updateTtdSP2D(response.data.ttdSP2D)
                        updateFirebasePencairan(dialogData, 5)
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const updateTtdSP2D = (params) => {
        const db = getDatabase();
        set(ref(db, 'ttdSP2D'), params);
    }

    const updateProsesSP2D = (params) => {
        const db = getDatabase();
        set(ref(db, 'prosesSP2D'), params);
    }

    const handleOpenDialogPrint = () => {
        setDialogData(data)
        handleCloseOption();
        setOpenDialogPrint(true);
    };

    const handleCloseDialogPrint = () => {
        setOpenDialogPrint(false);
    };

    return (
        <>
            <Tooltip title="Pilihan">
                <IconButton aria-label="option" onClick={handleOption}>
                    <MoreHoriz />
                </IconButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openOption}
                onClose={handleCloseOption}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={onCancel}>
                    <ListItemIcon>
                        <Clear color='error' />
                    </ListItemIcon>
                    Batal
                </MenuItem>
                <MenuItem onClick={onConfirm}>
                    <ListItemIcon>
                        <Check color="success" />
                    </ListItemIcon>
                    SP2D Ditandatangani
                </MenuItem>
                <MenuItem onClick={handleOpenDialog}>
                    <ListItemIcon>
                        <Info color="info" />
                    </ListItemIcon>
                    Info
                </MenuItem>
                <MenuItem onClick={handleOpenDialogPrint}>
                    <ListItemIcon>
                        <Print color="primary" />
                    </ListItemIcon>
                    Print Dokumen
                </MenuItem>
            </Menu>

            <MyDialog dialogData={dialogData} openDialog={openDialog} handleCloseDialog={handleCloseDialog} decryptedUser={decryptedUser} />
            <Dialog
                fullWidth={true}
                // fullScreen
                maxWidth="lg"
                open={openDialogPrint}
                // onClose={handleCloseDialogPrint}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">Print Dokumen</DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} lg={8}>
                            <Accordion expanded={true}>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>File Pengantar SP2D</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={
                                        base_url + '/uploads/' + dialogData.tahun_anggaran + '/' + dialogData.id_opd + '/pengantar_sp2d/' + dialogData.file
                                    } />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    {
                        dialogData.kontrak !== "" &&
                        <Grid container spacing={2} py={2} justifyContent="center">
                            <Grid item xs={12} lg={8}>
                                <Accordion expanded={true}>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                        <Typography>File Kartu Kontrol</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <iframe width='100%' height={700} title="Pdf" src={
                                            base_url + '/uploads/' + dialogData.tahun_anggaran + '/' + dialogData.id_opd + '/kartu_kontrol/' + dialogData.file
                                        } />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    }
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} lg={8}>
                            <Accordion expanded={true}>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>Surat Perjanjian</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={
                                        base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/surat_perjanjian/' + dialogData.file
                                    } />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} py={2} justifyContent="end">
                        <Grid item xs="auto">
                            <Button variant='contained' color='error' onClick={handleCloseDialogPrint}>
                                Tutup
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}

const ProsesSp2d = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Proses SP2D" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [menyimpan, setMenyimpan] = useState(false)
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        setBreadcrumbItem({ '/verif': 'Home', '': 'Proses SP2D' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Menux data={params.row} menyimpan={menyimpan} setMenyimpan={setMenyimpan} />
                );
            }
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = () => {
        console.log('req data');
        setTableLoading(true)
        axios.get(
            base_url + '/verif/pencairan/proses_sp2d',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menyimpan]);

    return (
        <Card>
            <CardHeader
                title="Proses SP2D"
            />
            <CardContent>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab icon={<AssignmentTurnedIn />} label="Terverifikasi" value="1" />
                                <Tab icon={<BorderColor />} label="SP2D Ditandatangani" value="2" />
                                <Tab icon={<Handshake />} label="SP2D Diserahkan" value="3" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <MyTable
                                rows={tableData}
                                columns={columns}
                                row_id={(row) => row.no_spm}
                                isLoading={tableLoading}
                            />
                        </TabPanel>
                        <TabPanel value="2">
                            <DataTtdSp2d />
                        </TabPanel>
                        <TabPanel value="3">
                            <DataSp2dDiserahkan />
                        </TabPanel>
                    </TabContext>
                </Box>
            </CardContent>
        </Card>
    )
}

export default ProsesSp2d
export { Data as DataProsesSp2d }